module.exports = __webpack_public_path__ + "static/media/about-01.09d309f5.jpg";